export default __webpack_public_path__ + "static/media/0Q5A1615-Gursahib-Singh.cc443f0a.jpg";